<template>
    <div class="body"
         v-infinite-scroll="loadmore"
         infinite-scroll-immediate="false">
        <div class="context">
            <header>
                <img src="../../../assets/images/zqc/header.jpg"
                     alt="致青春·为家国">
                <div class="new-tips"
                     v-if="lastUserName">
                    <span> 
        最新动态播报 {{lastUserName}} 上传了视频
    </span>
                </div>
                <div class="count-num">已有<strong> {{ animatedTotal }} </strong>人挑战</div>
                <div class="button"
                     @click="openRecordVideo">上传朗读视频</div>
            </header>
            <section class="img-group-gird3">
                <ul>
                    <li v-for="(grid,index) in grids3" :key="index">
                        <a @click="changeTab(index)">
                            <img :src="grid.img">
                            <span :class="grid.class">{{grid.title}}</span>
                        </a>
                    </li>
                    <!--<li>
                        <a href="">
                            <img src="../../../assets/images/zqc/test2.jpg" alt="青春">
                            <span class="txt-yellow">"青春"</span>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <img src="../../../assets/images/zqc/test2.jpg" alt="奉献">
                            <span class="txt-red">"奉献"</span>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <img src="../../../assets/images/zqc/test2.jpg" alt="奉献">
                            <span class="txt-blue">"家国"</span>
                        </a>
                    </li>-->
                </ul>
            </section>
            <section class="container" :class="tabclass">
                <div class="grid">
                    <waterfall :col='2'
                               :data="list">
                        <template>
                            <div class="grid-item item"
                                 :key="index"
                                 @click="watchVideo(item.id, item.newsId)"
                                 v-for="(item,index) in list">
                                <img :src="item.poster">
                                <div class="box-con">
                                    <div class="box-title"
                                         v-html="item.title"></div>
                                    <div class="box-company"
                                         v-if="item.company">
                                        推荐单位：<span>{{item.company}}</span>
                                    </div>
                                    <div class="box-love">
                                        <img class="box-header"
                                             :src="item.faceUrl">
                                        <div class="box-like">{{item.thumbUp}}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </waterfall>
                </div>
                <div class="loading"
                     v-if="limit != 0">
                    <img src="../../../assets/images/zqc/loading.png"
                         alt="加载更多">
                    <p>下滑获取更多</p>
                </div>
                <div class="loading"
                     v-if="limit == 0">
                    <p>已经加载全部内容</p>
                </div>
            </section>
        </div>

        <section>
            <a href="javascript:void(0);"
               @click="openRecordVideo">
                <img class="i-button"
                     src="../../../assets/images/zqc/i-upload.png"></a>
        </section>

        <section class="fix-bottom">
            <div class="bottom-content">
            <div class="com-log">
                <div class="com-log-tip">
                        <p style="height: 0.4rem;" v-if="comments.length"><strong>{{comments[currentCommentIndex]['username']}}：</strong> {{comments[currentCommentIndex]['content']}}</p>
                </div>
            </div>
            <div class="company-list">
                <a href="http://www.gxnews.com.cn/app/borad.php?action=add&bid=483">点击<br>留言</a>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import TweenLite from 'gsap';
import jsonp from 'jsonp';

import img_qc from "../../../assets/images/zqc/icon_qc.png";
import img_fx from "../../../assets/images/zqc/icon_fx.png";
import img_jg from "../../../assets/images/zqc/icon_jg.png";
export default {
    data () {
        return {
            lastUserName: '',
            company: [],
            comments: [],
            currentCommentIndex: 0,
            total: 0,
            tweenedTotal: 0,
            list: [],
            cateid: 147,
            tabclass: 'tab-red',
            col: 2,
            limit: 10,
            page: 1,
            isLoading: false,
            grids3:[
                {
                    link: '',
                    title: '"青春"',
                    img: img_qc,
                    class: 'txt-yellow',
                    tabclass: 'tab-yellow',
                    id: 146,
                },
                {
                    link: '',
                    title: '"奉献"',
                    img: img_fx,
                    class: 'txt-red',
                    tabclass: 'tab-red',
                    id: 147,
                },
                {
                    link: '',
                    title: '"家国"',
                    img: img_jg,
                    class: 'txt-blue',
                    tabclass: 'tab-blue',
                    id: 148,
                }
            ]
        }
    },
    computed: {
        animatedTotal: function () {
            return this.tweenedTotal.toFixed(0);
        }
    },
    watch: {
        total (newValue) {
            TweenLite.to(this.$data, 0.5, { tweenedTotal: newValue });
        },
        page () {
            this.isLoading = true
            this.axios.get('/webtopic/videoList/'+this.cateid+'?limit=' + this.limit + '&page=' + this.page).then((res) => {
                if (res.data.data.length) {
                    this.list = this.list.concat(this.dataMap(res.data.data))
                } else {
                    this.limit = 0
                }
            }).finally(() => {
                this.isLoading = false
            })
        }
    },
    methods: {
        dataMap (data) {
            return data.map((item) => {
                item.topic = []
                item.company = ''

                if (item.title) {
                    const reg1 = new RegExp('#[^ ]+(?= |\\s)', 'g')
                    item.title = item.title.replace(reg1, '<em>$&</em>')

                    const reg2 = new RegExp('\\(.*?\\)', 'g')

                    let company = item.title.match(reg2)
                    item.title = item.title.replace(reg2, '')

                    if (company) {
                        item.company = company[0].replace('(', '').replace(')', '')
                        if (item.company && this.company.indexOf(item.company) == -1) {
                            this.company.push(item.company)
                        }
                    }
                }
                return item;
            });
        },
        init () {
            this.isLoading = true
            this.axios.get('/webtopic/videoInit/'+this.cateid+'?limit=' + this.limit + '&page=' + this.page).then((res) => {
                const data = res.data.data
                this.lastUserName = data.lastUserName;
                //this.total = data.total;

                this.limit = data.list.length < this.limit ? 0 : 10;

                if (this.page == 1) {
                    this.list = this.dataMap(data.list)
                }
            }).finally(() => {
                this.isLoading = false
            })
            jsonp(`https://www.gxnews.com.cn/app/borad.php?action=list&bid=483&type=json`, {} , (err, data) => {
                this.isLoading = false;
                if (err) {
                    console.error(err.message);
                } else {
                    this.comments= data;
                }
            })  
            this.getTotal()
        },
        loadmore () {
            if (this.limit != 0 && !this.isLoading) {
                this.page++
            }
        },
        openRecordVideo () {
            this.$openZGApp("zgapp://gxnews.com.cn:8765/feature?type=0", "https://fun.gxnews.com.cn/zg/")
        },
        watchVideo (videoId, ItemId) {
            this.$openZGApp("zgapp://gxnews.com.cn:8765/browser?type=video&itemId=" + ItemId, "http://zgapp.gxnews.com.cn/h5/#/video/" + videoId)
        },
        getStatistPv () {
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=${encodeURIComponent('https://zgapp.gxnews.com.cn/h5/#/video-zqc')}&tag=zgapp-video&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })
        },
        changeTab(index){
            if( index==0 || index==2){
                this.tabclass = this.grids3[index].tabclass;
                this.page = 1; //清空重置
                this.limit = 10;
                this.cateid = this.grids3[index].id;
                if(index==0){
                    this.grids3.unshift(this.grids3[2]);
                    this.grids3.pop();
                }
                if(index==2){
                    this.grids3.push(this.grids3[0]);
                    this.grids3.shift();
                }
                this.init();
            }
        },
        getTotal(){
            this.total=0;
            this.axios.get('/webtopic/videoInit/146').then((res) => {
                this.total += res.data.data.total;
            }).finally(() => {
            })
            this.axios.get('/webtopic/videoInit/147').then((res) => {
                this.total += res.data.data.total;
            }).finally(() => {
            })
            this.axios.get('/webtopic/videoInit/148').then((res) => {
                this.total += res.data.data.total;
            }).finally(() => {
            })
        }
    },
    mounted () {
        document.title = "致青春·为家国——第二届广西青少年经典云共读活动";
        this.init();

        setInterval(() => {
            if (this.comments.length - 1 <= this.currentCommentIndex) {
                this.currentCommentIndex = 0;
            } else {
                this.currentCommentIndex++
            }
        }, 3000)

        this.$nextTick(() => {
            this.$bus.$emit('hideDownload', true)
        });
        this.getStatistPv();
    }
}
</script>

<style scoped>
.body {
    height: 100%;
    max-width: 20rem;
    font-size: 0.32rem;
    overflow-x: hidden;
}

.context {
    background: url("../../../assets/images/zqc/bg2.jpg") center top no-repeat #2b1901;
    background-size: contain;
}

.i-button {
    width: 1.853333rem;
    position: fixed;
    right: 0.32rem;
    bottom: 2.186667rem;
}

.loading {
    color: #fff;
    text-align: center;
    line-height: 0.8rem;
    padding-top: 0.4rem;
}

.loading img {
    display: block;
    width: 0.986667rem;
    margin: 0 auto;
    animation: rotate 1s linear infinite;
}
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

header {
    position: relative;
}

header img {
    width: 100%;
    display: block;
}

header .count-num {
    text-align: center;
    color: #fff;
    line-height: 0.8rem;
}

header .count-num strong {
    color: #fa4040;
    font-size: 0.4rem;
}

header .button {
    background: url(../../../assets/images/zqc/i-btn-upload.png) center/3.56rem 0.74667rem no-repeat;
    border-radius: 0.400000rem;
    width: 3.560000rem;
    margin: 0 auto 1.066667rem;
    color: #fff;
    height: 0.746667rem;
    line-height: 0.746667rem;
    font-size: 0.400000rem;
    font-weight: bold;
    text-align: center;
    font-size: 0;
}

header .new-tips {
    background: url("../../../assets/images/zqc/i-header.png") center
        right/auto  no-repeat;
    color: #fff;
    height: 0.746667rem;
    line-height: 0.746667rem;
    position: absolute;
    top: 0.96rem;
    left: 0;
    padding-left: 0.266667rem;
    padding-right: 0.533333rem;
}
.img-group-gird3{
    text-align: center;
}
.img-group-gird3 li {
    display: inline-block;
    font-size: 0.453333rem;
    vertical-align: middle;
    padding: 0 0.05rem;
}
.img-group-gird3 li img {
    border-radius: 0.066667rem;
    border: 1Px solid #8b481a;
    padding: 0.080000rem;
    width: 2.400000rem;
    height: 1.360000rem;
    margin-bottom: 0.133333rem;
}
.img-group-gird3 li:nth-child(2) img {
    width: 3.906667rem;
    height: 2.186667rem;
}
.img-group-gird3 li .txt-yellow {
    color: #ffa800;
}
.img-group-gird3 li .txt-red {
    color: #c00808;
}
.img-group-gird3 li .txt-blue {
    color: #628bff;
}
.img-group-gird3 li:nth-child(2) {
    font-size: 0.746667rem;
}
.img-group-gird3 li span {
    display: block;
    text-align: center;
    font-weight: bold;
}
.title {
    margin-bottom: 0.506667rem;
}

.title img {
    display: block;
    width: 100%;
}

.container {
    min-height: 10rem;
    padding-bottom: 2.453333rem;
    padding-top: 1.066667rem;
    margin-top: -0.400000rem;
}
.tab-yellow {
    background: url(../../../assets/images/zqc/tab-yellow.png) center top/100% no-repeat;
}
.tab-red {
    background: url(../../../assets/images/zqc/tab-red.png) center top/100% no-repeat;
}
.tab-blue {
    background: url(../../../assets/images/zqc/tab-blue.png) center top/100% no-repeat;
}

.grid {
    width: 96%;
    margin: 2% auto;
    overflow: hidden;
    position: relative;
}

.grid-item {
    margin: 0 0.1rem;
    /* float: left; */
    border-radius: 0.12rem 0.12rem 0 0;
    background: #fff;
    /* width: 48%; */
    margin-bottom: 0.333333rem;
    overflow: hidden;
}

.grid-item img {
    width: 100%;
    display: block;
}

.grid-item .box-con {
    background: url("../../../assets/images/zqc/i-point.png") 0.13333rem
        0.37333rem/0.44rem 0.6rem no-repeat;
    font-size: 0.346667rem;
    line-height: 0.533333rem;
    padding: 0.266667rem 0.266667rem 0.266667rem 0.533333rem;
    overflow: hidden;
}

.grid-item .box-title {
    border-bottom: 1px dashed #b5b5b5;
    font-weight: bold;
    padding-bottom: 0.333333rem;
    margin-bottom: 0.333333rem;
}

.grid-item .box-title >>> em {
    color: #b04b58;
    font-style: normal;
}

.grid-item .box-company {
    font-size: 0.32rem;
    margin-bottom: 0.333333rem;
}

.grid-item .box-header {
    width: 0.96rem;
    height: 0.96rem;
    border-radius: 50%;
    float: left;
}

.grid-item .box-love {
    overflow: hidden;
}

.grid-item .box-like {
    background: url("../../../assets/images/zqc/i-love.png") 0.13333rem
        0.10667rem/0.44rem no-repeat #ffa903;
    cursor: pointer;
    border-radius: 0.293333rem;
    color: #f9dd7c;
    height: 0.586667rem;
    line-height: 0.586667rem;
    font-size: 0.266667rem;
    float: right;
    padding: 0 0.293333rem 0 0.666667rem;
    margin-top: 0.186667rem;
}

.fix-bottom {

    background: rgba(249, 164, 1, 0.7);
    height: 1.6rem;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 0.333333rem;
}
.fix-bottom .bottom-content{
    max-width: 16rem;
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
}

.fix-bottom .com-log {
  width: 7.520000rem;
  height: 1.293333rem;
}

.fix-bottom .com-log .com-word {
    color: #850404;
    font-size: 0.373333rem;
    border-right: 1px solid #850404;
    padding-right: 0.08rem;
    margin-right: 0.08rem;
    float: left;
}

.fix-bottom .com-log .com-log-tip {
    background: #fff;
    width: 7.333333rem;
    height: 0.720000rem;
    overflow: hidden;
    color: #4f4848;
    line-height: 0.360000rem;
    float: left;
    padding: 0.266667rem;
}

.fix-bottom .com-log .com-log-tip strong {
    color: #cc0101;
}

.fix-bottom .company-list {
    color: #794d00;
    border-radius: 0.400000rem;
    background: #fff;
    line-height: 0.386667rem;
    font-weight: bold;
    height: 0.773333rem;
    width: 1.333333rem;
    padding: 0.240000rem 0.066667rem;
    text-align: center;
}
.fix-bottom .company-list a {
    color: #794d00;
}
</style>
